import RouteLeavingGuard from './RouteLeavingGuard';

export default RouteLeavingGuard;
export * from './types';
export { RouteLeavingGuard };
